
import Navigation from '../../components/base/Navigation';

export default function About() {
  return (
    <div className="min-h-screen bg-black text-white">
      <Navigation />
      
      <div className="pt-24 pb-16">
        <div className="max-w-6xl mx-auto px-6">
          <h1 className="text-3xl font-light mb-12 tracking-wide">ABOUT</h1>
          
          <div className="grid md:grid-cols-2 gap-12 mb-16">
            <div>
              <img
                src="https://static.readdy.ai/image/55007b31e14c3def396c32a0945c7f13/a2abc5a3eed157047a8ae4418214f5e3.png"
                alt="Designer portrait"
                className="w-full h-80 object-cover rounded-lg"
              />
            </div>
            <div className="space-y-8">
              <div>
                <h2 className="text-2xl font-light mb-6 tracking-wide">EXPERIENCE</h2>
                
                <div className="space-y-6">
                  <div>
                    <h3 className="text-lg font-medium text-white mb-2">QUÁCH NGỌC TUYÊN</h3>
                    <p className="text-gray-400 text-sm mb-1">FREELANCE FILM EDITOR (2025-PRESENT)</p>
                    <p className="text-gray-300 text-sm">Film: TRĂNG ĐIÊN</p>
                  </div>

                  <div>
                    <h3 className="text-lg font-medium text-white mb-2">A TÔ MAKING FILM</h3>
                    <p className="text-gray-400 text-sm mb-1">FREELANCE FILM EDITOR (2020 – PRESENT)</p>
                    <p className="text-gray-300 text-sm">Film: Bi Long Đại Ca, Yêu Lại Từ Đầu, Tương Sinh Tương Khắc</p>
                  </div>

                  <div>
                    <h3 className="text-lg font-medium text-white mb-2">BIG CAT ENTERTAINMENT – LALASCHOOL YOUTUBE CHANNEL & MIGO YOUTUBE CHANNEL</h3>
                    <p className="text-gray-400 text-sm mb-1">FILM EDITOR – COLOR GRADING (2017 – 2019)</p>
                    <p className="text-gray-300 text-sm">100+ clips uploaded, series: LaLa School 2, 3, 4, Nhỏ Lớp Trưởng, Nụ Hôn Ký Ức, Lan Quế Phường, Vệ Thần Tình Yêu, Music Video, Viral Clip...</p>
                  </div>

                  <div>
                    <h3 className="text-lg font-medium text-white mb-2">NÀNG PƠ LANG OFFICIAL</h3>
                    <p className="text-gray-400 text-sm mb-1">FREELANCE FILM EDITOR (2020 – PRESENT)</p>
                    <p className="text-gray-300 text-sm">Film: Một Nửa Sự Thật</p>
                  </div>

                  <div>
                    <h3 className="text-lg font-medium text-white mb-2">PKA FILM GROUP</h3>
                    <p className="text-gray-400 text-sm mb-1">FREELANCE FILM EDITOR – COLOR GRADING (2017 – PRESENT)</p>
                    <p className="text-gray-300 text-sm">Music Video: Cô Ấy Đã Từng, Gửi Em Người Anh Thương, Em Giấu Anh Điều Gì, Cố Chấp, Em Vẫn Chưa Về, Em Sẽ Hối Hận, Chuyện Tình Tà Đùng</p>
                  </div>

                  <div>
                    <h3 className="text-lg font-medium text-white mb-2">HN MEDIA</h3>
                    <p className="text-gray-400 text-sm mb-1">FREELANCE FILM EDITOR – COLOR GRADING (2017 – PRESENT)</p>
                    <p className="text-gray-300 text-sm">Series: Nơi Bắt Đầu Ước Mơ, Video Big Event FPT University</p>
                  </div>
                </div>
              </div>

              <div>
                <h2 className="text-2xl font-light mb-6 tracking-wide">SKILLS</h2>
                <div className="space-y-4">
                  <div>
                    <div className="flex justify-between items-center mb-2">
                      <span className="text-white font-medium">ADOBE PREMIERE</span>
                      <span className="text-gray-400 text-sm">7 YEARS</span>
                    </div>
                    <div className="w-full bg-gray-800 rounded-full h-2">
                      <div className="bg-white h-2 rounded-full" style={{width: '90%'}}></div>
                    </div>
                  </div>

                  <div>
                    <div className="flex justify-between items-center mb-2">
                      <span className="text-white font-medium">DAVINCI RESOLVE</span>
                      <span className="text-gray-400 text-sm">7 YEARS</span>
                    </div>
                    <div className="w-full bg-gray-800 rounded-full h-2">
                      <div className="bg-white h-2 rounded-full" style={{width: '90%'}}></div>
                    </div>
                  </div>

                  <div>
                    <div className="flex justify-between items-center mb-2">
                      <span className="text-white font-medium">ADOBE AFTER EFFECTS</span>
                      <span className="text-gray-400 text-sm">BASIC MOTION GRAPHIC/VFX</span>
                    </div>
                    <div className="w-full bg-gray-800 rounded-full h-2">
                      <div className="bg-white h-2 rounded-full" style={{width: '60%'}}></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
